import { Component } from 'react';
import { Avatar, Box } from '@mui/material';

import Contacts from './Contacts';

export default class Info extends Component {
  render() {
    return (
      <Box className='center-side-bar'>
        <Avatar className='avatar center-block' src='img/avatar/me.jpg' alt='LeKinaSá' sx={{ width: '50%', height: '50%' }} />
        <Box>
          <Box className='center-text big-text bold-text'>
            Clara Martins
          </Box>
          <Box className='center-text'>
            From V. N. Famalicão, Braga in Portugal
          </Box>
        </Box>
        <Contacts />
      </Box>
    );
  }
}
